import { syncDecryptedTimelineToRedux } from './decryptedListener';
import { installBackupKeyListener } from './backupKeyListener';
let installed = false;
let detach = null;
/**
 * Wire crypto/backup listeners into Redux once, as early as login allows.
 * Idempotent — safe to call from auth and again from App mount.
 */
export const installCryptoReduxBridge = (client, dispatch) => {
    if (installed && detach) {
        syncDecryptedTimelineToRedux(client.getRooms(), client, dispatch);
        return detach;
    }
    installed = true;
    const detachBackupKeyListener = installBackupKeyListener(client, dispatch);
    const resync = () => {
        syncDecryptedTimelineToRedux(client.getRooms(), client, dispatch);
    };
    resync();
    detach = () => {
        installed = false;
        detachBackupKeyListener();
        detach = null;
    };
    return detach;
};
